// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"x0-z","subtitle":"y0-z","wrapper":"z0-z","leftArrow":"A0-z","rightArrow":"B0-z"};